import { FC, useEffect } from "react";
import { useUnleashContext } from "@unleash/proxy-client-react";

import { normalizePhoneDigits } from "../../utils";
import { useGetProfileQuery } from "../../api/profile";

export const UnleashContextSync: FC = () => {
  const updateContext = useUnleashContext();
  const { data: profile } = useGetProfileQuery();
  const phone = profile?.phone;

  useEffect(() => {
    if (!phone) {
      return;
    }

    void updateContext({
      userId: normalizePhoneDigits(phone),
    });
  }, [phone, updateContext]);

  return null;
};
